( function ( $ ) {
	// Skip if no relevant elements
	if ( ! $( '.list-articles__article' ).length ) {
		return;
	}

	const $articles = $( '.list-articles__article' );

	// Desktop hover behavior
	$articles.on( 'mouseenter', function () {
		$articles.removeClass( 'active' );
		$( this ).addClass( 'active' );
	} );

	// Mobile scroll behavior
	if ( window.matchMedia( '(max-width: 767px)' ).matches ) {
		// Helper function to check if element is in viewport center
		function isInCenter( element ) {
			const rect = element.getBoundingClientRect();
			const windowHeight = window.innerHeight;
			const centerThreshold = windowHeight / 1.8;

			const elementCenter = rect.top + rect.height / 1.8;
			return (
				Math.abs( elementCenter - centerThreshold ) < rect.height / 1.8
			);
		}

		// Check articles on scroll
		$( window ).on( 'scroll', function () {
			$articles.each( function () {
				if ( isInCenter( this ) ) {
					$articles.removeClass( 'active' );
					$( this ).addClass( 'active' );
				}
			} );
		} );

		// Initial check on page load
		$( window ).trigger( 'scroll' );
	}
} )( jQuery );
